(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/components/result-distribution.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/components/result-distribution.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo;
const WinDivWrapper = svs.components.tipsen.winDiv.WinDivWrapper;
const useGetDrawState = svs.components.tipsen.hooksWager.useGetDrawState;
const useDrawResults = svs.components.tipsen.hooks.useDrawResults;
const drawStateEnums = svs.components.sport.tipsenShared.drawStateEnums;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const getDefinitionByProduct = svs.components.tipsen.engine.utils.getDefinitionByProduct;
const RemainingRows = svs.components.tipsen.remainingRows.RemainingRows;
const ResultDistribution = _ref => {
  var _getDefinitionByProdu;
  let drawNumber = _ref.drawNumber,
    productId = _ref.productId;
  const className = 'pg_windiv--result';
  const drawState = useGetDrawState(productId, drawNumber);
  const isDrawCompleted = drawState === drawStateEnums.FINALIZED;
  const _useDrawResults = useDrawResults({
      productId,
      drawNumber
    }),
    data = _useDrawResults.data;
  const _data = _slicedToArray(data, 3),
    drawResults = _data[0],
    winDivisions = _data[1],
    multiForecast = _data[2];
  const eventTypeId = ((_getDefinitionByProdu = getDefinitionByProduct(productId)) === null || _getDefinitionByProdu === void 0 ? void 0 : _getDefinitionByProdu.outcomes.eventTypeId) || undefined;
  const isGoalCount = useMemo(() => eventTypeId === EventTypeId.GOAL_COUNT, [eventTypeId]);
  const shouldDisplayRemainingRows = isGoalCount && !isDrawCompleted;
  return React.createElement(React.Fragment, null, React.createElement(WinDivWrapper, {
    className: className,
    drawNumber: drawNumber,
    drawResults: drawResults,
    drawWinDivs: winDivisions,
    isDrawCompleted: isDrawCompleted,
    multiForecast: multiForecast,
    productId: productId
  }), shouldDisplayRemainingRows && React.createElement(RemainingRows, {
    className: "pg_remaining_rows--result",
    drawNumber: drawNumber,
    productId: productId
  }));
};
setGlobal('svs.components.tipsen.routeResult.ResultDistribution', ResultDistribution);

 })(window);